/**
 * Submits the currency form when the currency is changed.
 */
class CurrencySelector extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    form.addEventListener('change', () => {
      form.submit();
    });
  }
}

customElements.get('currency-selector') ||
  customElements.define('currency-selector', CurrencySelector);
